import React from 'react'
import {
  CFView,
  CFText,
  CFImage,
  CFLink,
  DefaultScreen,
  MobileScreen,
} from 'components'
import Header from './Header'
import OrderPickupButton from './OrderPickupButton'
import OrderDeliveryButton from './OrderDeliveryButton'
import { hero, heroText, mobileHero, mobileHeroText } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView
          h="118vh"
          maxHeight="800px"
          w="100%"
          image={`url(${mobileHero}) bottom / cover no-repeat`}
          boxShadow="1px 1px 3px rgba(0,0,0,.6)"
          column
          alignCenter
        >
          <CFView textCenter w="100%">
            <CFView mt="6vh">
              <CFImage
                w="90%"
                src={mobileHeroText}
                alt="Naruto Sushi hero text"
                zIndex={98}
              />
            </CFView>
            <CFView pulsate mt="15px">
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          h="100vh"
          maxHeight="650px"
          w="100%"
          image={`url(${hero}) center / cover no-repeat`}
          zIndex={90}
          column
          justifyEnd
          alignEnd
        >
          <CFView column justifyCenter alignEnd mr="5%" h="100vh">
            <CFImage
              w="90vh"
              maxWidth="650px"
              src={heroText}
              alt="Naruto Sushi hero text"
              zIndex={98}
            />
            <CFView mv="30px" pulsate>
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
